import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideCalAngular } from '@cvx/cal-angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { appErrorInterceptor } from './services/app-error.interceptor';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, appErrorInterceptor])),
    provideCalAngular(environment.calConfigPath),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }
  ]
};
